<template>
  <div id="app">
    <router-view />
    <NotificationsContainer />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useAuthStore } from './stores/auth'
import NotificationsContainer from '@/components/ui/NotificationsContainer.vue'

const authStore = useAuthStore()

onMounted(async () => {
  // Initialize authentication state
  await authStore.init()
})
</script>